import DecisionModal from './DecisionModal';

export default DecisionModal;
